/**
 * Defines an {@link HTMLScriptElement} whose source is using modern ESM
 * modules with an optional fallback source for older browsers that do not
 * support ESM modules.
 */
export interface ModuleSource {
  module: string;
  fallback?: string;
}

/**
 * A type guard for testing that an object is assignable to the {@link ModuleSource}
 * type.
 *
 * @param argument
 */
export const isModuleSource = (argument: any): argument is ModuleSource => {
  // prettier-ignore
  return typeof argument === "object"
      && argument !== null
      && "module" in argument
      && typeof argument.module === "string"
      && (argument.fallback === undefined || typeof argument.fallback === "string");
};
